import { SalesOrderSortListField } from "@saleor/createOrder/urls";
import { Pagination, Sort } from "@saleor/types";
import { stringifyQs } from "@saleor/utils/urls";

export const listOfSaleOrderUrl = "/sales-order-list";
export const listOfSaleOrderTrackingUrl = "/sales-order-list-tracking";

export type SalesOrderUrlSort = Sort<SalesOrderSortListField>;
export type SalesOrderUrlQueryParams = Pagination & SalesOrderUrlSort;

export const salesOrderListUrl = (params?: SalesOrderUrlQueryParams) =>
  listOfSaleOrderUrl + "?" + stringifyQs(params);

export const salesOrderTrackingListUrl = (params?: SalesOrderUrlQueryParams) =>
  listOfSaleOrderTrackingUrl + "?" + stringifyQs(params);

export interface OrderProcessingParams {
  callback?: string;
}
